import Cookies from 'js-cookie';

export default {
    get: name => Cookies.get(name),
    set: (name, value, expires) => Cookies.set(name, value, { path: '/', expires: expires || 365 }),
    remove: name => Cookies.remove(name, { path: '/' })
}